import styled from 'styled-components'
import { space, typography, flexbox, layout } from 'styled-system'

export const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`
export const CenteredDiv = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin-top: 30px;
  border-bottom: 1px ${(props) => props.theme.colors.grey} solid;
  padding-bottom: 32px;
  ${layout}
`
export const CenteredRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  width: 90%;
  max-width: 950px;
  justify-content: space-around;
  @media (max-width: 740px) {
    flex-direction: column;
    align-items: center;
  }
`
export const Header = styled.h1`
  text-align: center;
  font-size: 22px;
  color: ${(props) => props.theme.colors.textColor};
  ${space}
`
export const ColouredText = styled.a`
  color: ${(props) => props.color};
  text-decoration: none;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.429;
  text-align: center;
  margin-right: 20px;
`
export const SpacerDiv = styled.div`
  width: 100%;
  height: 100px;
  text-align: center;
  margin-top: 40px;
`

export const CityText = styled.a`
  text-decoration: none;
  color: #555555;
  font-size: 16px;
  text-rendering: optimizelegibility;
  line-height: 1.4;
  padding-left: 10px;
  flex: 1 0 25%;
  display: flex;
  ${typography}
`
export const CityTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  @media (min-width: 700px) {
    height: 90px;
  }
  @media (min-width: 500px) and (max-width: 699px) {
    height: 200px;
  }
  align-content: center;
`

export const ImageColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${flexbox}
`
export const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-width: 740px) {
    align-items: center;
  }
  ${flexbox}
`
export const SmallHeader = styled.h1`
  font-size: 18px;
  font-weight: 700;
  line-height: 19.8px;
  color: ${(props) => props.theme.textColor};
  margin-bottom: 35px;
  margin-top: 0px;
  ${space}
`
export const SmallLink = styled.a`
  color: ${(props) => props.theme.textColor};
  font-size: 14px;
  text-decoration: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
  ${typography}
  ${space}
`
export const SmallText = styled.p`
  color: ${(props) => props.theme.textColor};
  margin-top: 4px;
  margin-bottom: 0px;
  font-size: 14px;
  ${space}
`

export const StyledBar = styled.hr`
  ${layout}
`
